<div class="lum-c-sales-order-shipment-status-cell-renderer">
  <i
    *ngIf="params.data?.salesOrderShipments?.length > 1; else singleShipment"
    class="fa fa-sitemap cursor-pointer"
    aria-hidden="true"
    matTooltip="Multiple Shipments"
    (click)="onToggleShipmentDetails()"
  ></i>

  <ng-template #singleShipment>
    <i
      *ngIf="params.data?.salesOrderShipments?.length === 1"
      class="fa fa-archive cursor-pointer"
      aria-hidden="true"
      matTooltip="Single Shipment"
      (click)="onToggleShipmentDetails()"
    ></i>
  </ng-template>
</div>
